import React from 'react';
import GalleryFilter from '../components/common/GalleryFilter';
import { usePageScripts } from '../hooks/useScripts';
import "../assets/css/gallery/style.css";

const Gallery = () => {
  usePageScripts('gallery');

  const galleryItems = [
    // Lounge images
    { image: '/assets/img/gallery/lounge/1.webp', alt: 'Lounge', title: 'Lounge', categories: ['all', 'lounge'] },
    { image: '/assets/img/gallery/lounge/2.webp', alt: 'Lounge', title: 'Lounge', categories: ['all', 'lounge'] },
    { image: '/assets/img/gallery/lounge/3.JPG', alt: 'Lounge', title: 'Lounge', categories: ['all', 'lounge'] },
    { image: '/assets/img/gallery/lounge/4.JPG', alt: 'Lounge', title: 'Lounge', categories: ['all', 'lounge'] },
    { image: '/assets/img/gallery/lounge/5.webp', alt: 'Lounge', title: 'Lounge', categories: ['all', 'lounge'] },
    { image: '/assets/img/gallery/lounge/6.webp', alt: 'Lounge', title: 'Lounge', categories: ['all', 'lounge'] },
    { image: '/assets/img/gallery/lounge/7.jpg', alt: 'Lounge', title: 'Lounge', categories: ['all', 'lounge'] },
    { image: '/assets/img/gallery/lounge/8.jpg', alt: 'Lounge', title: 'Lounge', categories: ['all', 'lounge'] },
    { image: '/assets/img/gallery/lounge/9.jpg', alt: 'Lounge', title: 'Lounge', categories: ['all', 'lounge'] },
    
    // Dining images
    { image: '/assets/img/gallery/dining/1.webp', alt: 'Dining', title: 'Dining', categories: ['all', 'dining', 'pool'] },
    { image: '/assets/img/gallery/dining/2.webp', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/3.webp', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/4.webp', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/5.webp', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/6.webp', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/7.webp', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/8.webp', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/9.webp', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/10.webp', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/11.jpg', alt: 'Dining', title: 'Dining', categories: ['all', 'dining', 'pool'] },
    { image: '/assets/img/gallery/dining/12.webp', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/13.webp', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/14.jpg', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/15.JPG', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/16.JPG', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    { image: '/assets/img/gallery/dining/17.JPG', alt: 'Dining', title: 'Dining', categories: ['all', 'dining'] },
    
    // Beverages images
    { image: '/assets/img/gallery/beverages/1.webp', alt: 'Beverages', title: 'Beverages', categories: ['all', 'beverages'] },
    { image: '/assets/img/gallery/beverages/2.webp', alt: 'Beverages', title: 'Beverages', categories: ['all', 'beverages'] },
    { image: '/assets/img/gallery/beverages/3.webp', alt: 'Beverages', title: 'Beverages', categories: ['all', 'beverages', 'restaurant'] },
    { image: '/assets/img/gallery/beverages/4.webp', alt: 'Beverages', title: 'Beverages', categories: ['all', 'beverages', 'restaurant'] },
    { image: '/assets/img/gallery/beverages/5.webp', alt: 'Beverages', title: 'Beverages', categories: ['all', 'beverages'] },
    { image: '/assets/img/gallery/beverages/6.JPG', alt: 'Beverages', title: 'Beverages', categories: ['all', 'beverages'] },
    { image: '/assets/img/gallery/beverages/7.JPG', alt: 'Beverages', title: 'Beverages', categories: ['all', 'beverages'] },
    { image: '/assets/img/gallery/beverages/8.JPG', alt: 'Beverages', title: 'Beverages', categories: ['all', 'beverages'] },
    { image: '/assets/img/gallery/beverages/9.JPG', alt: 'Beverages', title: 'Beverages', categories: ['all', 'beverages'] },
    
    // Events images
    { image: '/assets/img/gallery/events/1.webp', alt: 'Events', title: 'Events', categories: ['all', 'events'] },
    { image: '/assets/img/gallery/events/2.webp', alt: 'Events', title: 'Events', categories: ['all', 'events'] },
    { image: '/assets/img/gallery/events/3.webp', alt: 'Events', title: 'Events', categories: ['all', 'events'] },
    { image: '/assets/img/gallery/events/4.webp', alt: 'Events', title: 'Events', categories: ['all', 'events'] },
    { image: '/assets/img/gallery/events/5.webp', alt: 'Events', title: 'Events', categories: ['all', 'events'] },
    { image: '/assets/img/gallery/events/6.webp', alt: 'Events', title: 'Events', categories: ['all', 'events'] },
    { image: '/assets/img/gallery/events/7.webp', alt: 'Events', title: 'Events', categories: ['all', 'events'] },
    { image: '/assets/img/gallery/events/8.webp', alt: 'Events', title: 'Events', categories: ['all', 'events'] },
    
    // Restaurant images
    { image: '/assets/img/gallery/restaurant/1.webp', alt: 'Restaurant', title: 'Restaurant', categories: ['all', 'restaurant'] },
    { image: '/assets/img/gallery/restaurant/2.webp', alt: 'Restaurant', title: 'Restaurant', categories: ['all', 'restaurant'] },
    { image: '/assets/img/gallery/restaurant/3.webp', alt: 'Restaurant', title: 'Restaurant', categories: ['all', 'restaurant'] },
    { image: '/assets/img/gallery/restaurant/4.JPG', alt: 'Restaurant', title: 'Restaurant', categories: ['all', 'restaurant'] },
    { image: '/assets/img/gallery/restaurant/5.JPG', alt: 'Restaurant', title: 'Restaurant', categories: ['all', 'restaurant'] },
    
    // Pool images
    { image: '/assets/img/gallery/pool/1.webp', alt: 'Pool', title: 'Pool', categories: ['all', 'pool'] },
    { image: '/assets/img/gallery/pool/2.webp', alt: 'Pool', title: 'Pool', categories: ['all', 'pool'] },
    { image: '/assets/img/gallery/pool/3.webp', alt: 'Pool', title: 'Pool', categories: ['all', 'pool'] },
    { image: '/assets/img/gallery/pool/4.webp', alt: 'Pool', title: 'Pool', categories: ['all', 'pool'] },
    { image: '/assets/img/gallery/pool/5.JPG', alt: 'Pool', title: 'Pool', categories: ['all', 'pool'] },
    { image: '/assets/img/gallery/pool/6.JPG', alt: 'Pool', title: 'Pool', categories: ['all', 'pool'] },
    { image: '/assets/img/gallery/pool/7.jpg', alt: 'Pool', title: 'Pool', categories: ['all', 'pool'] },
    { image: '/assets/img/gallery/pool/8.JPG', alt: 'Pool', title: 'Pool', categories: ['all', 'pool'] },
    
    // Beach images
    { image: '/assets/img/gallery/beach/1.webp', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/2.JPG', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/3.JPG', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/4.JPG', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/5.webp', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/6.JPG', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/7.JPG', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/8.JPG', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/9.JPG', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/10.jpg', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/11.JPG', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/12.JPG', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/13.JPG', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] },
    { image: '/assets/img/gallery/beach/14.JPG', alt: 'Beach', title: 'Beach', categories: ['all', 'beach'] }
  ];

  const categories = ['all', 'lounge', 'dining', 'beverages', 'events', 'restaurant', 'pool', 'beach'];
  const lightboxSources = galleryItems.map(item => item.image);

  return (
    <>
      <div className="hero-gallery" style={{
        background: 'linear-gradient(rgba(81, 120, 116, 0.7), rgba(81, 120, 116, 0.7)), url("/assets/img/gallery/pool/1.webp")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '50vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        marginBottom: '0',
        position: 'relative',
        zIndex: 2
      }}>
        <div style={{ textAlign: 'center' }}>
          <small style={{
            color: '#ebd7b2',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '600',
            fontSize: '13px',
            textTransform: 'uppercase',
            letterSpacing: '2px',
            display: 'block',
            marginBottom: '15px'
          }}>MEMORIES IN FRAMES</small>
          <h1 style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '500',
            fontSize: '40px',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            margin: '0'
          }}>GALLERY</h1>
        </div>
      </div>
      <section className="gallery-section-two petti_cream_rep">
        <div className="auto-container">
          <GalleryFilter 
            items={galleryItems}
            categories={categories}
            defaultFilter="all"
            lightboxSources={lightboxSources}
          />
        </div>
      </section>
    </>
  );
};

export default Gallery;
